export default {
  title: 'Campos',
  description: 'Gerencie definições de campos reutilizáveis pelos tipos de card dos Boards.',
  form: {
    title: 'Campo',
    createTitle: 'Criar campo',
  },
  groups: {
    definition: 'Definição',
  },
  labels: {
    new: 'Novo campo',
  },
  fields: {
    key: 'Nome',
    label: 'Label',
    description: 'Descrição',
    options: 'Opções',
    defaultValue: 'Valor padrão',
    optionsHelp: 'Opções (uma por linha; use valor | texto exibido)',
    optionsPlaceholder: 'valor | texto exibido',
    optionPlaceholder: 'Digite um valor',
    addOption: 'Adicionar valor',
    removeOption: 'Remover valor',
    optionsMode: 'Como informar as opções',
    staticOptions: 'Lista de valores',
    dynamicSource: 'Fonte dinâmica',
    sourceScope: 'Escopo',
    productScope: 'Produto',
    sharedScope: 'Shared',
    sourceProduct: 'Produto proprietário',
    sourceService: 'Service',
    sourceDomain: 'Domínio',
    sourceModule: 'Module',
    sourceKey: 'Chave',
    type: 'Tipo',
    required: 'Obrigatório',
    active: 'Ativo',
  },
  types: {
    checkbox: 'Checkbox',
    switch: 'Switch',
    date: 'Data',
    datetime: 'Data e Hora',
    dateRange: 'Período (Data)',
    datetimeRange: 'Período (Data e Hora)',
    integer: 'Inteiro',
    decimal: 'Decimal',
    combo: 'Combo',
    checklist: 'Checklist',
    editorBasic: 'Editor simples',
    editorFull: 'Editor completo',
    // Compatibilidade para definições criadas pelo contrato anterior.
    text: 'Texto',
    textarea: 'Texto longo',
    number: 'Número',
    boolean: 'Sim/Não',
    editor: 'Editor',
  },
  errors: {
    BOARD_FIELD_KEY_INVALID: 'O Nome deve começar com uma letra minúscula e conter somente letras minúsculas, números e sublinhado, com até 100 caracteres.',
    alreadyExists: 'Já existe um campo com esse Nome.',
    identityRequired: 'Informe o Nome e o Label do campo.',
    typeInvalid: 'Selecione um tipo de campo válido.',
    inUse: 'Desvincule este campo de todos os tipos de card antes de excluí-lo.',
  },
};
